import { useMemo } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';
import { getIsOfferDynamicCalltrackingEnabled } from '../api/offerDynamicCalltracking';
import { useOfferContext } from '../context';

export function useOfferDynamicCalltrackingEnabled(): boolean {
  const { config } = useApplicationContext();
  const { offer } = useOfferContext();

  return useMemo(
    () => !offer.newbuildingDynamicCalltracking?.siteBlockId && getIsOfferDynamicCalltrackingEnabled(config, offer.geo),
    [config, offer.geo, offer.newbuildingDynamicCalltracking],
  );
}
